import { Grid, IconButton, Paper, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import { SaveButton, SimpleForm, Tab, TabbedShowLayout, Toolbar, useDataProvider } from "react-admin";
import { ModelState } from "../../Models/ModelStateEnum";
import PbhRequestOrderInfo from "../PbhInfo/PbhRequestOrderInfo";
import { useHistory, useLocation } from "react-router-dom";
import { PbhRequestOrderTabEnum } from "../../../../Enums/PbhRequestOrderTabEnum";
import PbhRequestServiceable from "../PbhRequestServiceable/PbhRequestServiceable";
import PbhRequestOrderFiles from "./PbhRequestOrderFiles";
import RequestHistoryTimeLine from "../RequestHistoryTimeLine";
import { GetUnserviceableStatus } from "../../../../Enums/UnserviceableStatus";
import PbhRequestUnserviceable from "../PbhRequestUnserviceable/PbhRequestUnserviceable";
import { useAccessControl, useAuth } from "@airborne/react-admin";
import { CloudDownload } from "@material-ui/icons";
import { RequestOrderTabEnum } from "../../../../Enums/RequestOrderTabEnum";
import { ExcelExport } from "../../../../Helper/ExportExcel";
import {
  PbhRequestOrderHistoryExcelName,
  PbhRequestOrderHistoryHeaders,
  RequestServiceableHistoryExcelName,
  RequestServiceableHistoryHeaders,
  RequestUnserviceableHistoryExcelName,
  RequestUnserviceableHistoryHeaders,
} from "./Pbh.constants";
import { SourcePbhRequestOrder } from "../Constant/Source";
import PbhRequestAlternatePn from "../PbhRequestAlternatePn/PbhRequestAlternatePn";
import PbhWaitingResponse from "../PbhWaitingResponse/PbhWaitingResponse";
import Swal from "sweetalert2";
import {
  PBH_REQUEST_SET_FILES,
  PBH_REQUEST_SET_FILES_LOADING,
  PBH_REQUEST_UPDATE_CLOSE,
  PBH_REQUEST_UPDATE_OPEN,
} from "../../../../Redux/actions";
import { connect } from "react-redux";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import { GetPbhRemoveReasonType } from "../../../../../src/Enums/PbhRemoveReasonType";
import { GetPbhRemoveReasonSubType } from "../../../../../src/Enums/RemoveReasonSubType";
import { formatMinutesToHourMinute } from "../../../../Helper/FormatMinutesToHourMinute";
import { PbhRequestFileType } from "../../../../Enums/PbhRequestFileType";

const BlankToolbar = props => (
  <Toolbar {...props} placeholder="" {...props} className="blank-toolbar">
    <SaveButton label="" />
  </Toolbar>
);

const ExportToExcelUnsvc = data => {
  ExcelExport(
    RequestUnserviceableHistoryHeaders,
    data.map(v => [
      v.pn,
      v.sn,
      v.awb,
      v.ac,
      v.flightNo,
      v.batch,
      formatMinutesToHourMinute(v.tso),
      v.cso,
      formatMinutesToHourMinute(v.tsr),
      v.csr,
      formatMinutesToHourMinute(v.tsn),
      v.csn,
      v.dsn,
      formatMinutesToHourMinute(v.tsi),
      v.csi,
      v.dsi,
      v.dso,
      v.dsr,
      v?.estimatedDeliveryDate != null ? v?.estimatedDeliveryDate : "",
      v?.forwardDateToCarrier != null ? v?.forwardDateToCarrier : "",
      v?.removeDateFromAc != null ? v?.removeDateFromAc : "",
      GetPbhRemoveReasonType.filter(x => x.Value == v?.removeReasonType)[0]?.Description ?? "",
      v?.removeReasonType != null
        ? ((GetPbhRemoveReasonSubType(v?.removeReasonType) as any)?.filter(x => x.Value == v?.removeReasonType)[0]
            ?.Description ?? "")
        : "",
      v.carrier,
      GetUnserviceableStatus.filter(x => x.Value == v.status)[0]?.Description ?? "",
      v.remark,
      v.removalReasonDetail,
      v.dom,
      v.adSbMod,
      v.nla,
      v.nha,
      v.replenishmentReason,
      v.rejectionRemark,
      v.createdBy,
      v.updatedBy,
      v?.createdDate != null ? v?.createdDate : "",
      v?.updatedDate != null ? v?.updatedDate : "",
    ]),
    RequestUnserviceableHistoryExcelName
  );
};

const ExportToExcelSvc = data => {
  ExcelExport(
    RequestServiceableHistoryHeaders,
    data.map(v => [
      v.createdBy,
      v?.createdDate != null ? v?.createdDate : "",
      v.updatedBy,
      v?.updatedDate != null ? v?.updatedDate : "",
      v.pn,
      v.sn,
      v.awb,
      v.flightNo,
      v.requestedDeliveryDate != null ? v?.requestedDeliveryDate : "",
      v.estimatedDeliveryDate != null ? v?.estimatedDeliveryDate : "",
      v.submittedBy,
      v.submittedDate != null ? v?.submittedDate : "",
      v.carrier,
      v.flightDate != null ? v?.flightDate : "",
    ]),
    RequestServiceableHistoryExcelName
  );
};

const ExportToInfoExcelInfo = data => {
  ExcelExport(
    PbhRequestOrderHistoryHeaders,
    data.map(v => [
      v.refNo,
      v.requestedDeliveryDate != null ? v?.requestedDeliveryDate : "",
      v.ataChapter,
      v.releaseType,
      v.airportCode,
      v.customerPo,
      v.customerPoLine,
      v.createdBy,
      v.updatedBy,
      v.createdDate != null ? v?.createdDate : "",
      v.updatedDate != null ? v?.updatedDate : "",
      v.pn,
      v.pnDescription,
      v.access,
      v.repair,
      v.isPool,
    ]),
    PbhRequestOrderHistoryExcelName
  );
};

const historyResource = [
  {
    id: RequestOrderTabEnum.ServiceableTab,
    source: "pbhrequestserviceables/svchistory",
    exportFunction: ExportToExcelSvc,
  },
  {
    id: RequestOrderTabEnum.UnServiceableTab,
    source: "pbhrequestunserviceables/unsvchistory",
    exportFunction: ExportToExcelUnsvc,
  },
  { id: RequestOrderTabEnum.InfoTab, source: "pbhrequestorders/history", exportFunction: ExportToInfoExcelInfo },
];

const PbhRequestOrderEdit = props => {
  const { user } = useAuth();
  const history = useHistory();
  const provider = useDataProvider();
  const [mainData, setMainData] = useState(null as any);
  const [waitingResponseVisible, setWaitingResponseTabVisible] = useState(true);
  const location = useLocation();
  const requestId: string = location?.pathname?.split("/")[2];
  const [activeTab, setActiveTab] = useState(RequestOrderTabEnum.InfoTab as string | number);
  const [selectedRequestOrderFileType, setSelectedRequestOrderFileType] = useState(null as number | null);
  const { canPerform: canPerformInfo } = useAccessControl(SourcePbhRequestOrder, "pbhrequestinfotab");

  React.useEffect(() => {
    isEightWingsRecord();
    getMainData();
    getWaitingResponseData();
  }, [requestId]);

  React.useEffect(() => {
    if (props.isPbhRequestInfoUpdate) {
      setSelectedRequestOrderFileType(PbhRequestFileType.Mailings);
    }
  }, [props.isPbhRequestInfoUpdate]);

  const isEightWingsRecord = async () => {
    provider
      .getList("eightwings", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "DESC" },
        filter: { requestId__eq: requestId },
      })
      .then(response => {
        const data: any = response.data[0];

        if (data?.id > 0 && data?.request?.requestStatus == PbhRequestStatus.SentEightWings) {
          history.push(`/eightwings/${data?.id}`);
        }
      })
      .catch(error => {});
  };

  const historyButtonVisible = (): boolean => {
    if (user?.isCustomer) return false;
    let tab = Number(activeTab);
    if (!historyResource.find(x => x.id == tab)) return false;
    if (tab === RequestOrderTabEnum.UnServiceableTab && mainData?.pbhRequestUnserviceable === null) return false;
    if (tab === RequestOrderTabEnum.ServiceableTab && mainData?.pbhRequestServiceable === null) return false;

    return true;
  };

  const unserviceableTabVisible = (): boolean => {
    if (isPageDisabled) return false;

    if (
      mainData?.requestStatus === PbhRequestStatus.Open ||
      mainData?.requestStatus === PbhRequestStatus.WaitingPoolScope
    ) {
      return false;
    }
    if (user?.isCustomer === true) {
      return true;
    } else {
      return mainData?.pbhRequestUnserviceable !== null;
    }
  };

  const serviceableTabVisible = (): boolean => {
    if (isPageDisabled) return false;

    if (
      mainData?.requestStatus === PbhRequestStatus.Open ||
      mainData?.requestStatus === PbhRequestStatus.WaitingPoolScope
    ) {
      return false;
    }
    if (user?.isCustomer === true) {
      return mainData?.pbhRequestServiceable !== null;
    } else {
      return true;
    }
  };

  const altPnTabVisible = (): boolean => {
    if (isPageDisabled) return false;

    if (
      mainData?.requestStatus === PbhRequestStatus.Open ||
      mainData?.requestStatus === PbhRequestStatus.WaitingPoolScope
    ) {
      return false;
    }
    if (user?.isCustomer === true) {
      return mainData?.alternatePn?.length > 0;
    } else {
      return true;
    }
  };


  const getTablesHistory = async (source: string, key: number) => {
    return provider.getRequestTablesHistoryList(source, key);
  };

  const exportHistory = e => {
    let selectedResource = historyResource.filter(condition => condition.id === Number(activeTab))[0];
    let key =
      selectedResource.id === RequestOrderTabEnum.UnServiceableTab
        ? mainData.pbhRequestUnserviceable.id
        : selectedResource.id === RequestOrderTabEnum.ServiceableTab
          ? mainData.pbhRequestServiceable.id
          : mainData.id;
    getTablesHistory(selectedResource.source, key).then((response: any) => {
      let data = response.data;
      selectedResource.exportFunction(data);
    });
  };

  const getWaitingResponseData = () => {
    provider
      .getList("pbhwaitingresponses", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "ASC" },
        filter: { requestId__eq: requestId },
      })
      .then(({ data }) => {
        setWaitingResponseTabVisible(data.length > 0 ? true : false);
      })
      .catch(error => {
        console.error(error);
        setWaitingResponseTabVisible(false);
      });
  };
  const getMainData = async () => {
    props?.setFilesLoading(true);
    provider
      .getOne("pbhrequestorders", { id: requestId })
      .then(response => {
        if (response?.data?.id === 0) {
          Swal.fire({
            title: "Error!",
            text: "Data not found",
            icon: "warning",
            iconColor: "#c80c0f",
            confirmButtonText: "Ok",
            confirmButtonColor: "#c80c0f",
          }).finally(() => {
            history.goBack();
          });
        } else {
          setMainData(response.data);
          // Combine both pbhRequestOrderFiles and coreInfoRequestFiles
          const allFiles = [
            ...(response.data?.pbhRequestOrderFiles || []),
            ...(response.data?.coreInfoRequestFiles || []),
          ];
          props?.setFiles(allFiles);
        }
      })
      .catch(error => {})
      .finally(() => props?.setFilesLoading(false));
  };

  const parentCallBack = async e => {
    getMainData();
  };

  // Check if page should be disabled due to RejectedDueToPoolScope status
  const isPageDisabled = mainData?.requestStatus === PbhRequestStatus.RejectedDueToPoolScope;

  const changeRequestOrderFileType = value => {
    setSelectedRequestOrderFileType(value.target.value);
  };

  React.useEffect(() => {
    let currentTab: string | number = location?.pathname?.split?.("/")?.[3];
    currentTab = currentTab ? currentTab : RequestOrderTabEnum.InfoTab;
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location?.pathname]);

  return (
    <SimpleForm submitOnEnter={false} toolbar={<BlankToolbar />}>
      <Grid container spacing={2} style={{ width: "100%" }}>
        <Grid item xs={12} sm={9}>
          <form>
            <Paper>
              <>
                <TabbedShowLayout value={1}>
                  {mainData !== null && canPerformInfo && (
                    <Tab id="info" key="info" label="INFO">
                      <PbhRequestOrderInfo
                        id="pbhrequestinfotab"
                        ModelState={ModelState.Edit}
                        DataSource={mainData}
                        isPageDisabled={isPageDisabled}
                      />
                    </Tab>
                  )}
                  {serviceableTabVisible() && (
                    <Tab
                      id="serviceable"
                      key="serviceable"
                      label="SERVICEABLE"
                      path={PbhRequestOrderTabEnum.ServiceableTab.toString()}
                    >
                      <PbhRequestServiceable
                        requestId={requestId}
                        requestDetailData={mainData}
                        requestServiceableData={mainData?.pbhRequestServiceable ?? null}
                        parentCallBack={parentCallBack}
                        isPageDisabled={isPageDisabled}
                      />
                    </Tab>
                  )}
                  {unserviceableTabVisible() && (
                    <Tab
                      id="unserviceable"
                      key="unserviceable"
                      label="CORE UNIT"
                      path={PbhRequestOrderTabEnum.UnserviceableTab.toString()}
                    >
                      <PbhRequestUnserviceable
                        ModelState={ModelState.Create}
                        requestId={requestId}
                        requestDetailData={mainData}
                        requestUnserviceableData={mainData?.pbhRequestUnserviceable ?? null}
                        parentCallBack={parentCallBack}
                        isPageDisabled={isPageDisabled}
                      />
                    </Tab>
                  )}
                  {altPnTabVisible() && (
                    <Tab
                      id="alternatepn"
                      key="alternatepn"
                      label="ALTERNATE PN"
                      path={PbhRequestOrderTabEnum.AltenatePn.toString()}
                    >
                      <PbhRequestAlternatePn
                        ModelState={ModelState.Create}
                        requestId={requestId}
                        requestAlternatePn={mainData?.alternatePn ?? null}
                        requestDetailData={mainData}
                        parentCallBack={parentCallBack}
                        isPageDisabled={isPageDisabled}
                      />
                    </Tab>
                  )}

  
                    <Tab
                      id="waitingresponsefromcustomer"
                      key="waitingresponsefromcustomer"
                      label="WAITING RESPONSE FROM CUSTOMER"
                      path={PbhRequestOrderTabEnum.WRFC.toString()}
                    >
                      <PbhWaitingResponse
                        setWaitingResponseTabVisible={setWaitingResponseTabVisible}
                        requestId={requestId}
                        mainData={mainData}
                        isPageDisabled={isPageDisabled}
                      />
                    </Tab>

                  {historyButtonVisible() && (
                    <IconButton
                      {...props}
                      size="medium"
                      style={{ color: "#c80c0f", margin: "auto", marginRight: "unset" }}
                      onClick={exportHistory}
                    >
                      <Tooltip title="History Export">
                        <CloudDownload />
                      </Tooltip>
                    </IconButton>
                  )}
                </TabbedShowLayout>
              </>
            </Paper>
            <PbhRequestOrderFiles
              mainData={mainData}
              activeTab={activeTab}
              changeRequestOrderFileType={changeRequestOrderFileType}
              selectedRequestOrderFileType={selectedRequestOrderFileType}
              getRequestDetail={getMainData}
              requestId={requestId}
              isPageDisabled={isPageDisabled}
              {...props}
            />
          </form>
        </Grid>
        <Grid item xs={12} sm={3}>
          <Paper>
            <Tab id="history" key="history" label="HISTORY">
              <RequestHistoryTimeLine
                isShowFooter={user?.isCustomer == false && mainData?.isManualChanged}
                footerMessages={[" * Status has been changed manually."]}
                request={mainData}
                source="PbhRequestOrderHistorys"
              />
            </Tab>
          </Paper>
        </Grid>
      </Grid>
    </SimpleForm>
  );
};

const mapStateToProps = state => ({
  files: state.pbhFiles.files,
  isPbhRequestInfoUpdate: state.pbhRequestInfoUpdate.isUpdate,
});
const mapDispatchToProps = dispatch => ({
  updateClose: () => dispatch({ type: PBH_REQUEST_UPDATE_CLOSE }),
  updateOpen: () => dispatch({ type: PBH_REQUEST_UPDATE_OPEN }),
  setFiles: data => dispatch({ type: PBH_REQUEST_SET_FILES, payload: data }),
  setFilesLoading: loading => dispatch({ type: PBH_REQUEST_SET_FILES_LOADING, payload: loading }),
});
export default connect(mapStateToProps, mapDispatchToProps)(PbhRequestOrderEdit);
